import React, { useEffect, useState, Fragment, useContext, useRef } from 'react';
import axios from 'axios';
import { LoginContext } from '../../hooks/context/LoginContext';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner'
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import MiSelect from '../../componentes/formulario/MiSelect';
import BaseSelect from "react-select";
import swal from 'sweetalert';
import { alertService } from '../../services/alertservice';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import MiInputDataTableLargeInv from '../../componentes/formulario/MiInputDatabTableLargeInv';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';

import { SRLWrapper } from 'simple-react-lightbox';

import { getApiUrl, getPantDocFromNivel, getStockOptionsSelectUbi, setStockOptionsSelectUbi, setStockOptionsSelectUbiLarge, getDecodedCookie, btnsImportExportFile, importFileToBBDD } from '../../helpers/helperApp';

// JS
import 'datatables.net';              // DataTables core
import 'datatables.net-dt';           // DataTables base para estilo DT
import 'datatables.net-bs4';          // Integración con Bootstrap 4
import 'datatables.net-buttons';      // Buttons core
import 'datatables.net-buttons-bs4';  // Buttons para Bootstrap 4
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';       // Select (debe ir después de DataTables)
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';   // Responsive core


let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0' + h : h = h) + '/' + (mesHoy < 10 ? mesHoy = '0' + mesHoy : mesHoy = mesHoy) + '/' + date.getFullYear();

var botones = [
    {
        extend: 'pdf',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        orientation: 'landscape',
        title: hoy,
        // titleAttr: 'Exportar a pdf',
        exportOptions: {
            columns: ':visible'
        }
    },
    {
        extend: 'excel',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        title: hoy,
        // titleAttr: 'Exportar a excel',
        exportOptions: {
            columns: ':visible'
        }
    },
];

function MiDataTableEdiRap(props) {


    const cookies = new Cookies();

    const { apiKey, confApp } = useContext(LoginContext);

    const loginState = useContext(LoginContext);


    // ***** props *****
    const { id, data, saveData, columnas, formulario, optionSelectUbi, optionSelectUni, inputNum1, swaldelete, isEdiRapComp, confPantalla, removeEye } = props;
    let { buttons, ordering, order, searching, paging, select, saveLoadingTable, loadingTable, columnactions, traduction, linkColumns, functionClickTd, pagelength, columnsFunctionClickTd, selectUbi, selectUni, idFiltro, editar, docBloqueado, importexcel, importExportFile, fnReloadTable, idRegImportExport } = props;

    const tableRef = useRef(null);
    const fileInputRef = useRef(null);

    const [loadingSelectUbi, saveLoadingSelectUbi] = useState(false);
    const [optionsSelectUbiState, saveOptionsSelectUbiState] = useState(optionSelectUbi);
    const [optionsSelectUbiStateBackUp, saveOptionsSelectUbiStateBackUp] = useState(optionSelectUbi);


    useEffect(() => {

        const accionesMiDataTable = columnas.find(column => column["title"] === columnactions);

        // Si ya existe la columna de acciones la eliminamos ya que sino da error cuando seleccionas un reg, vas a otra pantalla, vuelves y seleccionas otro reg.        
        if (accionesMiDataTable !== undefined) {
            columnas.splice((columnas.length - 1), 1);
        }

        // Añadimos los enlaces a los td
        if (linkColumns != undefined) {
            for (let i = 0; i < columnas.length; i++) {
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {

                    if (linkColumns[i] != undefined) {
                        // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'
                        if ('style' in rowData) {
                            $(td).addClass(rowData["style"]);
                        }
                        //Creamos los enlaces
                        // Si el enlace es a la pantalla de documentos obtenemos la pantalla que le corresponde según su id
                        if (linkColumns[i].link == "/documentos") {
                            linkColumns[i].link = getPantDocFromNivel(getDecodedCookie('nivel'));
                        }
                        if (linkColumns[i].data.includes("/") && linkColumns[i].link != "") {
                            const links = linkColumns[i].data.split("/");
                            $(td).html("<a href='" + window.location.origin + linkColumns[i].link + "/" + rowData[links[0]] + "/" + rowData[links[1]] + "' >" + cellData + "</a>");
                        } else if (linkColumns[i].link != "") {
                            $(td).html("<a href='" + window.location.origin + linkColumns[i].link + "/" + rowData[linkColumns[i].data] + "' >" + cellData + "</a>");
                        }
                    }
                    // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                    if ('foto' in rowData || 'img' in rowData) {
                        if (cellData) {
                            if (cellData.includes('/assets/')) {
                                $(td).html("<img src='" + getApiUrl(window.location.origin) + cellData + "' style='width: 100px !important; cursor: pointer;' />");
                            }
                        } else {
                            $(td).html("<span></span>");
                        }
                    }
                    if (functionClickTd) {
                        if (columnsFunctionClickTd) {
                            if (columnsFunctionClickTd.includes(col)) {
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        } else {
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < columnas.length; i++) {

                columnas[i].createdCell = (td, cellData, rowData, row, col) => {

                    // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'
                    if ('style' in rowData) {
                        $(td).addClass(rowData["style"]);
                    }
                    // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                    if ('foto' in rowData || 'img' in rowData) {
                        if (cellData) {
                            if (cellData.includes('/assets/')) {

                                let templateFoto = `
                                    <div>                                   
                                            <div class="containerImgTablePending">
                                                <img class="imgUplmTablePending" src=${getApiUrl(window.location.origin) + cellData} />
                                            </div>                                                                                                                                        
                                    </div>
                                    `;
                                $(td).html(templateFoto);
                                // $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 100px !important; cursor: pointer' />");
                            }
                        } else {
                            $(td).html("<span></span>");
                        }
                    }
                    if (functionClickTd) {
                        if (columnsFunctionClickTd) {
                            if (columnsFunctionClickTd.includes(col)) {
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        } else {
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }
                    }
                }
            }
        }

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0, "asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;
        select === undefined ? select = false : select = select;

        if (importexcel != null && importexcel != undefined) {
            const btnImportExcel = {
                text: `<i style='font-size: 20px;' class='fal fa-download'></i>`,
                className: 'btn btn-flat mr-1 btn-outline-secondary',
                extend: 'excelHtml5',
                exportOptions: {
                    columns: ':all' // Exportamos todas las columnas, visibles y no visibles
                    // columns: [0, 1, 3] // exporta solo las columnas 0, 1 y 3
                },
                action: function () {
                    // Activa el input de archivo oculto
                    if (fileInputRef.current) {
                        fileInputRef.current.click();
                    }
                }
            };
            // Verificamos si el botón ya existe en el array
            const existeBtn = botones.some(
                (boton) => boton.text === btnImportExcel.text && boton.className === btnImportExcel.className
            );

            // Si no existe, lo añadimos
            if (!existeBtn) {
                botones.push(btnImportExcel);
            }
        }

        columnas.map((columna, i) => {

            if (i == 0) {
                columna.createdCell = (td, cellData, rowData, row, col) => {

                    let templateNecesario = ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className='row pt-2'>
                                <div className='col-12'>
                                    <MiSelectLarge
                                        regActual={idRegImportExport ? idRegImportExport : 0}
                                        value={{ value: rowData.articulo, label: rowData.articuloNom }}
                                        saveValue={saveData}
                                        saveValueIsArray={{ id: rowData.id, valuekey: "articulo", labelkey: "articuloNom" }}
                                        label={""}
                                        col={12}
                                        confPantalla={confPantalla}
                                        dataType={confPantalla.edirap.controles.idunilarge.datatype}
                                        dataSql={confPantalla.edirap.controles.idunilarge.data}
                                        multiLinea={confPantalla.edirap.controles.idunilarge.multilinea}
                                        functionAfterChange={e => handleChangeUni(e, rowData)}
                                        readOnly={docBloqueado == true ? true : false}
                                    />
                                </div>
                            </div>
                        </LoginContext.Provider>
                        , td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);
                }
            }
            if (i == 2) {
                columna.createdCell = (td, cellData, rowData, row, col) => {

                    let templateNecesario = ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className="row pt-2">
                                <div className="col-12" >
                                    <div className='form-group' style={{ marginBottom: "8px" }}>
                                        <MiInputDataTableLargeInv
                                            valueProp={rowData.cantidad}
                                            saveValueProp={saveData}
                                            functionAfterChange={e => handleChangeNum1(e, rowData)}
                                            saveValueIsArray={{ id: rowData.id, valuekey: "cantidad" }}
                                            readOnly={docBloqueado == true ? true : false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </LoginContext.Provider>
                        , td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);
                }
            }
            if (i == 3 && isEdiRapComp != true) {
                columna.createdCell = (td, cellData, rowData, row, col) => {
                    const renderValue = setStockOptionsSelectUbiLarge([{ value: rowData.ubicacionactual, label: rowData.ubicacionNom }])[0];
                    let templateNecesario = ReactDOM.render(
                        <LoginContext.Provider value={loginState}>
                            <div className='row pt-2'>
                                <div className='col-12'>
                                    <MiSelectLarge
                                        regActual={idRegImportExport ? idRegImportExport : 0}
                                        value={renderValue}
                                        saveValue={saveData}
                                        saveValueIsArray={{ id: rowData.id, valuekey: "ubicacionactual", labelkey: "ubicacionNom" }}
                                        label={""}
                                        col={12}
                                        confPantalla={confPantalla}
                                        dataType={confPantalla.edirap.controles.idubilarge.datatype}
                                        dataSql={confPantalla.edirap.controles.idubilarge.data}
                                        multiLinea={confPantalla.edirap.controles.idubilarge.multilinea}
                                        functionAfterChange={e => handleChangeUbi(e, rowData)}
                                        unidad={{ value: rowData.articulo, label: rowData.articuloNom }}
                                        minCharSearch={0}
                                        readOnly={docBloqueado == true ? true : false}
                                    />
                                </div>
                            </div>
                        </LoginContext.Provider>
                        , td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario);
                }
            }
            if ((i == 4 && isEdiRapComp != true) || (i == 2 && isEdiRapComp == true)) {
                // Editar y Borrar
                columna.createdCell = (td, cellData, rowData, row, col) => {
                    let templateNecesario = ReactDOM.render(
                        <div className="flex-center">
                            {removeEye ? null : <a
                                className="btn btn-outline-primary mr-1"
                                href={getPantDocFromNivel(getDecodedCookie('nivel')) + "/" + rowData["iddoc"] + "/" + rowData["id"]}
                            >
                                <i className="fal fa-eye"></i>
                            </a>
                            }

                            {
                                docBloqueado == false
                                    ?
                                    <span
                                        id={rowData.id}
                                        className="btn btn-outline-danger deleteRow mr-1"
                                        // style={{border: 0}}
                                        onClick={e => { handleDeleteItem(e) }}>
                                        <i
                                            id={rowData.id}
                                            className="fal fa-trash-alt deleteRow"
                                            onClick={e => { handleDeleteItem(e, rowData) }}
                                        >
                                        </i>
                                    </span>
                                    : null
                            }
                            {
                                editar
                                    ?
                                    <span
                                        id={rowData.id}
                                        className="btn btn-outline-primary mr-1"
                                        // style={{border: 0}}
                                        onClick={e => { handleEditar(e, rowData) }}>
                                        <i
                                            id={rowData.id}
                                            className="fal fa-edit "
                                            onClick={e => { handleEditar(e, rowData) }}
                                        >
                                        </i>
                                    </span>
                                    :
                                    null
                            }
                            <div className={"col-1 mt-2 noDisplay spinDel_" + rowData.id}>
                                <i className="fal fa-spinner fa-spin"></i>
                            </div>
                            <div className={"col-1 mt-1 noDisplay errorDel_" + rowData.id} style={{ padding: 0, color: "#dc3545" }}>
                                <i className="fal fa-times fa-2x"></i>
                            </div>
                        </div>
                        , td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)
                }
            }
        })

        if (importExportFile == true) {
            botones = [...botones];
            botones = btnsImportExportFile(saveLoadingTable, traduction, fileInputRef, botones, id, data, idRegImportExport);
        }

        let auxColumnDefs = [
            { "type": "html-input-uni", "targets": 0 },
            { "type": "html-input", "targets": 1 },
            { "type": "html-input-ubi", "targets": 2 }
        ];
        if (isEdiRapComp == true) {
            auxColumnDefs = [
                { "type": "html-input-uni", "targets": 0 },
                { "type": "html-input", "targets": 1 }
            ];
        }

        if ($.fn.DataTable.isDataTable("." + id)) {
            let oTable = $("." + id).DataTable();
            oTable.destroy();
        }
        $("." + id).DataTable({
            mark: true,
            rowId: function (a) {
                return '#row-' + a.id;
            },
            columnDefs: auxColumnDefs,
            dom: buttons,
            data: data && data.length > 0 ? data : [],
            columns: columnas,
            ordering: ordering,
            order: order,
            searching: searching,
            paging: paging,
            select: select,
            buttons: [botones],
            responsive: false,
            autoWidth: false,
            retrieve: true,
            pageLength: parseInt(pagelength),
            lengthMenu: [
                [10, 25, 50, 100],
                ['10', '25', '50', '100']
            ],
            deferRender: true,
            language: {
                "sProcessing": traduction.sprocessing.title,
                "sLengthMenu": traduction.slengthmenu.title,
                "sZeroRecords": traduction.szerorecords.title,
                "sEmptyTable": traduction.semptytable.title,
                "sInfo": traduction.sinfo.title,
                "sInfoEmpty": traduction.sinfoempty.title,
                "sInfoFiltered": traduction.sinfofiltered.title,
                "sInfoPostFix": traduction.sinfopostfix.title,
                "sSearch": traduction.ssearch.title,
                "sUrl": traduction.surl.title,
                "sInfoThousands": traduction.sinfothousands.title,
                "sLoadingRecords": traduction.sloadingrecords.title,
                "oPaginate": {
                    "sFirst": traduction.sfirst.title,
                    "sLast": traduction.slast.title,
                    "sNext": traduction.snext.title,
                    "sPrevious": traduction.sprevious.title
                },
                "oAria": {
                    "sSortAscending": traduction.ssortascending.title,
                    "sSortDescending": traduction.ssortdescending.title
                },
                select: {
                    rows: traduction.rows.title
                },
                buttons: {
                    copyTitle: traduction.copytitle.title,
                    copyKeys: traduction.copykeys.title,
                    copySuccess: {
                        _: traduction.copysuccess.many.title,
                        1: traduction.copysuccess.one.title
                    },
                }
            },
            rowCallback: function (row, data, index) {
                // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                for (let item of row.children) {
                    if (item.outerText.includes("#")) {
                        item.bgColor = item.outerText;
                        item.innerText = "";
                    }
                }
            }
        })

        if (saveLoadingTable) {
            saveLoadingTable(false);
        }

    }, [data, formulario.id, docBloqueado])

    const handleImportFileToBBDD = (e, saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport) => {
        importFileToBBDD(saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport, e)
    }

    const handleChangeUbi = async (e, rowData) => {

        let spinner = document.getElementById(`spinTableLarge`);
        if (spinner) spinner.classList.remove('noDisplay');

        let idLinea = rowData.id;
        let idUbi = rowData.ubicacionactual;

        const dataForm = new FormData();
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("idubi", idUbi);
        dataForm.append("iduni", rowData.articulo)
        const respuesta = await axios.post(getApiUrl(window.location.origin) + "/edirap/updateUbicacion", dataForm);

        if (respuesta.data == idLinea) {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.children[2].classList.add('alert-success');
            }
        } else if (typeof respuesta.data == "string") {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.children[2].classList.add('alert-danger');
            }
        }

        if (spinner) spinner.classList.add('noDisplay');

    }

    const handleChangeNum1 = async (e, rowData) => {

        let spinner = document.getElementById(`spinTableLarge`);
        if (spinner) spinner.classList.remove('noDisplay');

        let idLinea = rowData.id;
        let num1 = rowData.cantidad;

        const dataForm = new FormData();
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("num1", num1);
        const respuesta = await axios.post(getApiUrl(window.location.origin) + "/edirap/updateNum1", dataForm);

        spinner.classList.toggle('noDisplay');

        if (respuesta.data == idLinea) {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.children[1].classList.add('alert-success');
            }
        } else if (typeof respuesta.data == "string") {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.children[1].classList.add('alert-danger');
            }
        }

        if (spinner) spinner.classList.add('noDisplay');

    }

    const handleChangeUni = async (e, rowData) => {
        let spinner = document.getElementById(`spinTableLarge`);
        if (spinner) spinner.classList.remove('noDisplay');

        let idLinea = rowData.id;
        let idUni = rowData.articulo;

        const dataForm = new FormData();
        dataForm.append("validacion", apiKey());
        dataForm.append("idlinea", idLinea);
        dataForm.append("iduni", idUni);
        const respuesta = await axios.post(getApiUrl(window.location.origin) + "/edirap/updateUnidad", dataForm);

        if (respuesta.data == idLinea) {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.firstChild.classList.add('alert-success');
            }
        } else if (typeof respuesta.data == "string") {
            let tr = document.getElementById(`#row-${idLinea}`);
            if (tr) {
                tr.firstChild.classList.add('alert-danger');
            }
        }

        if (spinner) spinner.classList.add('noDisplay');
    }

    const handleDeleteItem = (e, rowData) => {
        e.stopPropagation();
        let idLinea = e.target.id;
        swal({
            title: swaldelete.title,
            text: swaldelete.text.title,
            icon: "warning",
            buttons: {
                cancel: { text: swaldelete.btncancel.title, className: 'btn btn-flat mr-1 btn-outline-secondary', visible: true },
                confirm: { text: swaldelete.btnconfirm.title, className: 'btn btn-flat mr-1 btn-outline-danger btnSwalDelete' }
            }
        }).then(confirmacion => {
            if (confirmacion) {
                deleteLinea(idLinea);
            }
        })
    }

    const deleteLinea = async (idLinea) => {
        let spinner = document.querySelector(".spinDel_" + idLinea);

        if (spinner) {
            spinner.classList.toggle('noDisplay');
        }

        const dataForm = new FormData();
        dataForm.append("validacion", apiKey());
        dataForm.append("id", idLinea);
        const respuesta = await axios.post(getApiUrl(window.location.origin) + "/lineas/deletelineas", dataForm);
        if (respuesta.data !== 0) {
            // Borrado correcto. Borramos el tr
            const tr = document.querySelector("#\\#row-" + idLinea);
            if (tr) {
                tr.remove();
            }
            // Actulizamos los datos del state del datatable para que se refresque correctamente
            const auxData = $("." + id).DataTable().rows().data().filter(aux => {
                if (aux.id != idLinea) {
                    return aux;
                }
            })
            saveData(auxData);

        } else if (typeof respuesta.data == "string") {
            // Error borrando
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, { autoClose: true });
            if (spinner) {
                spinner.classList.toggle('noDisplay');
            }
        }
    }

    const handleEditar = (e, rowData) => {
        e.stopPropagation();
        editar(e, rowData);
    }


    // Busqueda en los input, select de la tabla
    $.fn.dataTableExt.ofnSearch['html-input'] = function (value) {
        if (/^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.test(value) || /^(\d{4})-(\d\d)-(\d\d)$/.test(value)) {
            // return dateSqlToLocal(value+"T00:00", getDecodedCookie('idioma'));
            return value;
        } else {
            return value;
        }
    };

    $.fn.dataTableExt.ofnSearch['html-input-uni'] = function (value) {
        if (optionSelectUni) {
            const busqueda = optionSelectUni.filter(option => option.value == value)
            if (busqueda[0]) {
                return busqueda[0].label;
            } else {
                return value;
            }
        } else {
            return null;
        }
    };

    $.fn.dataTableExt.ofnSearch['html-input-ubi'] = function (value) {
        if (optionSelectUbi) {
            const busqueda = optionSelectUbi.filter(option => option.value == value)
            if (busqueda[0]) {
                return busqueda[0].label;
            } else {
                return value;
            }
        } else {
            return null;
        }
    };


    // Código para evitar los acentos en las búsquedas
    function removeAccents(data) {
        if (data.normalize) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data + ' ' + data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }

        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;

    searchType.string = function (data) {
        return !data ?
            '' :
            typeof data === 'string' ?
                removeAccents(data) :
                data;
    };

    searchType.html = function (data) {
        return !data ?
            '' :
            typeof data === 'string' ?
                removeAccents(data.replace(/<.*?>/g, '')) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas





    return (
        <Fragment>
            {loadingTable ?
                <div style={{ height: 50, marginTop: 5, marginBottom: 10, textAlign: "center" }} >
                    {/* <Spinner animation="border" /> */}
                    <SpinnerFloat />
                </div>
                :
                null
            }
            <div style={{ overflowX: "auto" }}>
                <div id="spinTableLarge" className="noDisplay" style={{ textAlign: "center" }} >
                    {/* <Spinner animation="border" /> */}
                    <SpinnerFloat />
                </div>
                <table id={id} className={id + " table table-sm table-bordered table-striped table-hover dataTable"} style={{ width: "99%" }} ></table>
                {/* Input de archivo oculto para la importación de Excel */}
                <input
                    id="importFileToBBDD"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xls,.xlsx"
                    // onChange={ e => importFileToBBDD(saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport)}
                    onChange={e => handleImportFileToBBDD(e, saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport)}
                />
            </div>

        </Fragment>
    )
}

export default MiDataTableEdiRap;